export function setGridPageSize(pageSize) {
  if (!pageSize) localStorage.removeItem('grid_page_size')
  else localStorage.setItem('grid_page_size', pageSize.toString())
}

export function getGridPageSize() {
  const pageSize = localStorage.getItem('grid_page_size')
  return pageSize ? parseInt(pageSize, 10) : null
}
